import Users from './Users';
import Home from './Home';
import Plus from './Plus';
import Minus from './Minus';
import CaretDown from './CaretDown';
import Close from './Close';
import CircleNotice from './CircleNotice';

export default {
    Users, Home, Plus, Minus, CaretDown, Close, CircleNotice,
};
